'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _dropbox = require('dropbox');

var _dropbox2 = _interopRequireDefault(_dropbox);

var _utils = require('helpers/utils');

var _auth = require('redux/modules/auth');

var authAction = _interopRequireWildcard(_auth);

var _cloud = require('redux/modules/cloud');

var cloudActions = _interopRequireWildcard(_cloud);

var _components = require('components');

var _cloud2 = require('selectors/cloud');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var dropboxImg = require('assets/dropbox-icon.png');

var service = 'dropbox';

var DropboxPopup = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    error: (0, _cloud2.getError)(state, service),
    files: (0, _cloud2.getFiles)(state, service),
    pathId: (0, _cloud2.getPathId)(state, service),
    pathCollection: state.cloud[service].pathCollection,
    processing: (0, _cloud2.getProcessing)(state, service),
    user: state.auth.user
  };
}, (0, _extends3.default)({}, authAction, cloudActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(DropboxPopup, _Component);

  function DropboxPopup() {
    var _ref;

    (0, _classCallCheck3.default)(this, DropboxPopup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropboxPopup.__proto__ || (0, _getPrototypeOf2.default)(DropboxPopup)).call.apply(_ref, [this].concat(args)));

    _this.onAuth = function (e) {
      window.removeEventListener('onDropboxAuth', _this.onAuth);
      _this.authWindow.close();
      _this.authWindow = null;

      var accessToken = e.detail.access_token;
      if (accessToken) {
        _this.props.setBoxToken(service, accessToken).promise.then(function () {
          _this.initDropboxClient({ accessToken: accessToken });
          _this.openCloudBrowser();
        });
      }
    };

    _this.getFileFromResp = function (item) {
      return {
        service: service,
        uniqId: item.__id + '-' + Date.now(),
        url: item.link,
        name: item.metadata.name,
        size: item.metadata.size
      };
    };

    _this.state = { files: [] };
    return _this;
  }

  (0, _createClass3.default)(DropboxPopup, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _get3.default)(DropboxPopup.prototype.__proto__ || (0, _getPrototypeOf2.default)(DropboxPopup.prototype), 'componentDidMount', this).call(this, this.initDropbox);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _get3.default)(DropboxPopup.prototype.__proto__ || (0, _getPrototypeOf2.default)(DropboxPopup.prototype), 'componentWillUnmount', this).call(this, this.destroyDropbox);
    }
  }, {
    key: 'onSelect',
    value: function onSelect(item, breadcrumb) {
      if (item && item.__type === 'folder') {
        this.loadPath(item.path_lower, this.getPathCollection(item));
      } else if (typeof breadcrumb !== 'undefined') {
        this.loadPath(breadcrumb.id, breadcrumb.pathCollection);
      }
    }
  }, {
    key: 'onResult',
    value: function onResult(items) {
      var _this2 = this;

      var itemsArr = (0, _values2.default)(items);
      if (!itemsArr.length) {
        return false;
      }

      var _props = this.props,
          setProcessing = _props.setProcessing,
          onAdd = _props.onAdd;


      setProcessing(service, true);
      var promises = [];

      itemsArr.map(function (item) {
        var promise = _this2.Dropbox.filesGetTemporaryLink({ path: item.path_lower });
        promises.push(promise.then(_this2.getFileFromResp));
      });

      _promise2.default.all(promises).then(function (resp) {
        _this2.closeCloudBrowser();
        setProcessing(service, false);
        onAdd(resp);
      }).catch(function () {
        return setProcessing(service, false);
      });
    }
  }, {
    key: 'getRootPathCollection',
    value: function getRootPathCollection() {
      var t = this.props.t;

      return [{ id: '', name: t('Dropbox files') }];
    }
  }, {
    key: 'getPathCollection',
    value: function getPathCollection(item) {
      var _this3 = this;

      var res = [];
      var pathArr = item.path_lower.split('/');
      var fullPath = '';

      pathArr.map(function (entry, index) {
        if (!index) {
          res.push.apply(res, (0, _toConsumableArray3.default)(_this3.getRootPathCollection()));
        } else {
          fullPath += '/' + entry;
          res.push({ id: fullPath, name: entry });
        }
      });

      return res;
    }
  }, {
    key: 'destroyDropbox',
    value: function destroyDropbox() {
      this.Dropbox = null;
    }
  }, {
    key: 'initDropboxClient',
    value: function initDropboxClient(params) {
      this.Dropbox = null;
      this.Dropbox = new _dropbox2.default((0, _extends3.default)({ clientId: _config2.default.app.dropbox.appKey }, params));
    }
  }, {
    key: 'loadPath',
    value: function loadPath(pathId) {
      var _this4 = this;

      var pathCollection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getRootPathCollection();
      var _props2 = this.props,
          setFiles = _props2.setFiles,
          setError = _props2.setError,
          setPath = _props2.setPath,
          setPathCollection = _props2.setPathCollection;

      var isSamePath = function isSamePath() {
        return _this4.props.pathId === pathId;
      };
      setPath(service, pathId);
      setPathCollection(service, pathCollection);

      this.Dropbox.filesListFolder({ path: pathId }).then(function (resp) {
        return isSamePath() ? setFiles({ service: service, pathId: pathId, files: resp.entries }) : false;
      }).catch(function (err) {
        return isSamePath() ? setError(service, err.error) : false;
      });
    }
  }, {
    key: 'openCloudBrowser',
    value: function openCloudBrowser() {
      this.modal.open();
      this.loadPath('');
    }
  }, {
    key: 'closeCloudBrowser',
    value: function closeCloudBrowser() {
      this.modal.close();
    }
  }, {
    key: 'initDropbox',
    value: function initDropbox() {
      var user = this.props.user;

      var params = {};
      if (user.dropboxToken) {
        params.accessToken = user.dropboxToken;
      }
      this.initDropboxClient(params);
    }
  }, {
    key: 'openDropbox',
    value: function openDropbox(forceAuth) {
      var user = this.props.user;


      if (!user.dropboxToken || forceAuth) {
        var authUrl = this.Dropbox.getAuthenticationUrl(document.location.origin + '/processing/cloudauth/dropbox');
        this.authWindow = (0, _utils.popupWindowCenter)(authUrl, service, 380, 480);
        window.addEventListener('onDropboxAuth', this.onAuth);
      } else {
        this.openCloudBrowser();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props3 = this.props,
          t = _props3.t,
          files = _props3.files,
          error = _props3.error,
          pathId = _props3.pathId,
          pathCollection = _props3.pathCollection,
          processing = _props3.processing,
          fileTypes = _props3.fileTypes,
          disabled = _props3.disabled;


      var modalProps = {
        backdrop: true,
        closeByEsc: false,
        title: t('Add Dropbox files'),
        bsSize: 'lg',
        withoutPadding: true,
        simpleHeader: true
      };

      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'button',
          { type: 'button', className: 'btn btn-clear', onClick: function onClick() {
              return _this5.openDropbox();
            }, disabled: disabled },
          _react2.default.createElement(
            _components.Tooltip,
            { placement: 'bottom', title: 'Dropbox' },
            _react2.default.createElement('img', { src: dropboxImg, alt: '' })
          )
        ),
        _react2.default.createElement(
          _components.Modal,
          (0, _extends3.default)({ ref: function ref(el) {
              return _this5.modal = el;
            } }, modalProps),
          _react2.default.createElement(_components.CloudBrowser, {
            items: files,
            fileTypes: fileTypes,
            service: service,
            pathId: pathId,
            pathCollection: pathCollection,
            error: error,
            processing: processing,
            onCancel: this.closeCloudBrowser,
            onSelect: this.onSelect,
            onResult: this.onResult,
            onError: function onError() {
              return _this5.openDropbox(true);
            }
          })
        )
      );
    }
  }]);
  return DropboxPopup;
}(_ClientSideComponent2.default), _class3.propTypes = {
  disabled: _propTypes2.default.bool,
  error: _propTypes2.default.string,
  files: _propTypes2.default.array,
  fileTypes: _propTypes2.default.array,
  onAdd: _propTypes2.default.func,
  pathCollection: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string,
    name: _propTypes2.default.string,
    path: _propTypes2.default.string
  })),
  pathId: _propTypes2.default.string,
  processing: _propTypes2.default.bool,
  setBoxToken: _propTypes2.default.func,
  setError: _propTypes2.default.func,
  setFiles: _propTypes2.default.func,
  setPath: _propTypes2.default.func,
  setPathCollection: _propTypes2.default.func,
  setProcessing: _propTypes2.default.func,
  t: _propTypes2.default.func,
  user: _propTypes2.default.object
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSelect', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSelect'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onResult', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onResult'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'destroyDropbox', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'destroyDropbox'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'closeCloudBrowser', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'closeCloudBrowser'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'initDropbox', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'initDropbox'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = DropboxPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Dropbox/DropboxPopup.js
// module id = 1990
// module chunks = 1